import type { ApplicantJuridicalDraft } from '../models/juridical-schema'

export const INITIAL_DATA_CLIENT_JURIDICAL: ApplicantJuridicalDraft = {
  entity: {
    type: '',
    detail: ''
  },
  registrationDate: '',
  jurisdiction: '',
  cpe: false,
  entityAddress: {
    country: '',
    address: '',
    zone: 0
  },
  companyName: '',
  tradeName: '',
  societyFormation: false,
  economicActivitySpecific: '',
  website: '',
  shareholding: false,
  phone: [],
  email: []
}

export const INITIAL_DATA_REPRESENTATIVES_JURIDICAL = []

export const INITIAL_DATA_ECONOMIC_JURIDICAL = {
  suppliers: [],
  clients: [],
  sourceFunds: [],
  monthlyIncomes: [],
  monthlyExpenses: [],
  businessRelationship: '',
  numberEmployees: 0,
  numberOffices: 0
}

export const INITIAL_DATA_FATCA_JURIDICAL = {
  foundedUSA: false,
  isFinancialInstitution: false,
  hasTIN: false,
  hasGIIN: false,
  citizenShareholdersUSA: false,
  sendOrReceiveFundsUSA: false
}

export const INITIAL_DATA_KYC_JURIDICAL = {
  companyScope: '',
  contact: {
    name: '',
    phone: '',
    email: ''
  },
  originResources: [],
  retainIVA: false,
  retainISR: false,
  transacctions: {
    investment: '',
    disinvestment: ''
  },
  operationsMonthly: {
    investment: '',
    disinvestment: ''
  },
  comments: ''
}

export const INITIAL_DATA_END_BENEFICIARIES_JURIDICAL = {
  typeBeneficiary: ''
}
